import { Component, Output, EventEmitter } from '@angular/core';

import { EditCellDefault } from './edit-cell-default';
import { Cell } from '../../../lib/data-set/cell';

@Component({
    selector: 'table-cell-default-editor',
    templateUrl: './default-edit.component.html',
    standalone: false
})
export class DefaultEditComponent extends EditCellDefault {
  @Output() public blur = new EventEmitter<any>();

  constructor() {
    super();
  }

  public onBlur($event) {
    this.blur.emit({
      event: $event,
      column: this.cell.getColumn(),
      validator: this.cell.getRow().getValidator()
    });
  }

  public getEditorType(): string {
    return this.cell.getColumn().editor && this.cell.getColumn().editor.type;
  }
}
